import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from '@angular/router';
import { CheckerDataService, CheckerSettings } from '../../services/checker-data.service';
import { CheckerMode } from '../config-checker/config-checker.component';
import { ConfigCheckerAuthService } from '../../services/config-checker-auth.service';
import { Subscription } from 'rxjs';
// import standardPaths from '../standard_paths.json';

@Component({
  selector: 'app-config-checker-settings',
  templateUrl: './config-checker-settings.component.html',
  styleUrls: ['./config-checker-settings.component.scss'],
})
export class ConfigCheckerSettingsComponent implements OnInit, OnDestroy {

  checkerSettings: CheckerSettings = {
    checkerMode: 'default',
    onlyChanged: false,
    onlyRendered: false,
    onlyNewPages: false,
    onlyReachedPages: false,
    onlyDeadEnds: false,
    enableComparison: true,
    enableMetricOverviewPage: true,
    enableMetricInfoPage: true,
    designTag: '',
    defaultDesignTag: 'biozoom',
    viewMode: false,
    selectedAppPath: 'all',
  };

  availableAppPaths: { name: string, index: number }[] = [];
  availableDesigns: { _id: string, designTag: string }[] = [];
  private authSubscription: Subscription;

  constructor(
    private checkerDataService: CheckerDataService,
    private router: Router,
    public authService: ConfigCheckerAuthService,
    private http: HttpClient,
  ) {

  }

  ngOnInit() {
    const savedSettings = this.checkerDataService.getSettings();
    if (savedSettings) {
      this.checkerSettings = {
        ...this.checkerSettings,
        ...savedSettings
      };
    }

    const homePage = this.checkerDataService.getHomePage();
    if (homePage && homePage.state?.persistentValues?.CONFIG_NAME) {
      this.checkerSettings.designTag = homePage.state.persistentValues.CONFIG_NAME;
    } else {
      this.checkerSettings.designTag = 'WIP - BiozoomFull - Default';
    }

    this.updateSettings();

    this.availableAppPaths = [
      { name: 'all', index: -1 },
      { name: 'aox', index: 1 },
      { name: 'hrv', index: 23 },
      { name: 'vitality', index: 6 },
      { name: 'refreshConfig', index: 7 },
      { name: 'menuOverlay', index: 9 },
      { name: 'WIFI-Pairing', index: 18 },
    ];

    this.authSubscription = this.authService.isLoggedIn$.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.fetchAvailableDesigns();
      }
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  fetchAvailableDesigns() {
    const homePage = this.checkerDataService.getHomePage();
    const baseUrl = homePage?.state?.persistentValues?.urlConfigChecker || 'https://api-de.biozoom.net';
    this.http.get<{ _id: string, designTag: string }[]>(`${baseUrl}/v2/config/designList?name_only=true`, {
      headers: this.authService.getAuthHeaders(),
      withCredentials: true
    })
      .subscribe({
        next: (designs) => {
          this.availableDesigns = designs;
        },
        error: (err) => {
          console.error('Error fetching designs:', err);
        }
      });
  }

  openChecker(viewMode: boolean) {
    this.checkerSettings.viewMode = viewMode;
    this.updateSettings();
    void this.router.navigate(['/config-checker']);
  }

  goBack() {
    this.authService.logout().subscribe({
      next: () => {
        this.checkerDataService.isCheckerActive = false;
        void this.router.navigate(['/home']);
      },
      error: (err) => {
        console.error('Logout error during goBack:', err);
        this.checkerDataService.isCheckerActive = false;
        void this.router.navigate(['/home']);
      }
    });
  }

  updateSettings(): void {

    console.log('saving', this.checkerSettings);

    this.checkerDataService.setSettings({
      ...this.checkerSettings
    });
  }

  updateCheckerMode(checkerMode: CheckerMode): void {

    this.checkerSettings = {
      ...this.checkerSettings,
      checkerMode
    };

    this.updateSettings();
  }

  updateOnlyChanged(onlyChanged: boolean): void {

    this.checkerSettings = {
      ...this.checkerSettings,
      onlyChanged
    };

    this.updateSettings();
  }

  updateOnlyRendered(onlyRendered: boolean): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      onlyRendered
    };
    this.updateSettings();
  }

  updateOnlyNewPages(onlyNewPages: boolean): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      onlyNewPages
    };
    this.updateSettings();
  }

  updateOnlyReachedPages(onlyReachedPages: boolean): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      onlyReachedPages
    };
    this.updateSettings();
  }

  updateOnlyDeadEnds(onlyDeadEnds: boolean): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      onlyDeadEnds
    };
    this.updateSettings();
  }

  updateEnableComparison(enableComparison: boolean): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      enableComparison
    };
    this.updateSettings();
  }

  updateEnableMetricOverviewPage(enableMetricOverviewPage: boolean): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      enableMetricOverviewPage
    };
    this.updateSettings();
  }

  updateEnableMetricInfoPage(enableMetricInfoPage: boolean): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      enableMetricInfoPage
    };
    this.updateSettings();
  }

  updateDefaultDesignTag(defaultDesignTag: string): void {
    console.log('updateDefaultDesignTag', defaultDesignTag);
    this.checkerSettings = {
      ...this.checkerSettings,
      defaultDesignTag
    };
    this.updateSettings();
  }

  updateSelectedAppPath(selectedAppPath: string): void {
    this.checkerSettings = {
      ...this.checkerSettings,
      selectedAppPath
    };
    this.updateSettings();
  }


}


